<div class="decrypt-field">
  {{ label }}
  <button
    class="decrypt-button"
    type="button"
    matIconButton
    color="primary"
    matTooltip="Click to see raw value"
    matTooltipPosition="below"
    [matTooltipShowDelay]="500"
    (click)="decryptValue(value, title)"
  >
    <mat-icon>lock_open</mat-icon>
  </button>
</div>
